import { store } from "../store/index";
import {
  filterWorkingPart,
  removeWorkingPart,
  modifyWorkingPart,
  getWorkingPartByUuid,
  createWorkingPart,
  filterMyWorkingPart,
  getDailyPartByUuid,
  validateDailyPart,
  confirmDailyPart,
  listDailyPartToExport,
  reportTaskHour,
  confirmAllDailyPart,
  createAdminWorkingPart,
  removeDailyWorkingPart,
  updatePartDates,
  filterAllWorkingPart,
  listWorkingPartToExport,
} from "../store/actions/WorkingPartActions";

/**
 * Create WorkingPart
 */
export const addWorkingPart = async (values, dailyUuid) => {
  const objSend = { ...values };
  if (objSend.rows.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(createWorkingPart(objSend, [dailyUuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Create WorkingPart
 */
export const adminAddWorkingPart = async (values) => {
  const objSend = { ...values };
  if (objSend.rows.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(createAdminWorkingPart(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get WorkingPart
 */
export const getWorkingPart = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getWorkingPartByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update WorkingPart
 */
export const updateWorkingPart = async (values, uuid) => {
  const objSend = { ...values };
  if (objSend.rows.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(modifyWorkingPart(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List WorkingPart
 */
export const listFilter = async (filter, isTechnical) => {
  let result;
  if (isTechnical) {
    result = await store.dispatch(filterMyWorkingPart(filter));
  } else {
    result = await store.dispatch(filterWorkingPart(filter));
  }
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete WorkingPart
 */
export const deleteWorkingPart = async (uuid) => {
  const result = await store.dispatch(removeWorkingPart([uuid]));
  if (result?.payload?.data === "DELETE_ALL") {
    return "DELETE_ALL";
  } else if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete WorkingPart
 */
export const deleteDailyWorkingPart = async (uuid) => {
  const result = await store.dispatch(removeDailyWorkingPart([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get WorkingPart
 */
export const getDailyPart = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getDailyPartByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Validate WorkingPart
 */
export const validateDailyWorkingPart = async (uuid) => {
  const result = await store.dispatch(validateDailyPart([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Confirm WorkingPart
 */
export const confirmDailyWorkingPart = async (uuid) => {
  const result = await store.dispatch(confirmDailyPart([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Confirm WorkingPart
 */
export const confirmAllDailyWorkingPart = async (filter) => {
  const result = await store.dispatch(confirmAllDailyPart(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
/**
 * List order
 */
export const listToExportDaily = async (filter) => {
  const result = await store.dispatch(listDailyPartToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List workingParts
 */
export const listToExportWorking = async (filter) => {
  const result = await store.dispatch(listWorkingPartToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List report task hour
 */
export const reportListTaskHour = async (filter) => {
  const result = await store.dispatch(reportTaskHour(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update WorkingPart and DailyPart date
 */
export const updateDateParts = async (values, uuid) => {
  const objSend = { ...values };
  if (objSend.length <= 0) {
    objSend.rows = [];
  }
  const result = await store.dispatch(updatePartDates(objSend, [uuid]));
  if (result) {
    return "OK";
  }
  return null;
};

/**
 * List WorkingPart
 */
export const listAllWorkingPartUnitsFilter = async (filter) => {
  let result;
  result = await store.dispatch(filterAllWorkingPart(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
